export function groupFieldsByDependency(
  miscellaneousFields: Record<string, any>
): string[][] {
  if (!miscellaneousFields) return [];

  return Object.keys(miscellaneousFields).reduce(
    (groups: string[][], fieldName) => {
      const field = miscellaneousFields[fieldName];
      const dependencyFieldName = field?.validation?.compareField;
      if (!dependencyFieldName) {
        groups.push([fieldName]);
      } else {
        const group = groups.find((group) =>
          group.some((groupFieldName) => groupFieldName === dependencyFieldName)
        );
        if (group) {
          group.push(fieldName);
        } else {
          groups.push([fieldName]);
        }
      }
      return groups;
    },
    []
  );
}
